var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TrendUp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.0001 7.6416V15.6416C30.0001 15.9068 29.8947 16.1612 29.7072 16.3487C29.5196 16.5362 29.2653 16.6416 29.0001 16.6416C28.7349 16.6416 28.4805 16.5362 28.293 16.3487C28.1054 16.1612 28.0001 15.9068 28.0001 15.6416V10.0554L17.7076 20.3491C17.6147 20.4421 17.5044 20.5158 17.383 20.5662C17.2616 20.6165 17.1315 20.6424 17.0001 20.6424C16.8687 20.6424 16.7385 20.6165 16.6171 20.5662C16.4957 20.5158 16.3854 20.4421 16.2926 20.3491L12.0001 16.0554L3.70757 24.3491C3.51993 24.5367 3.26543 24.6422 3.00007 24.6422C2.7347 24.6422 2.48021 24.5367 2.29257 24.3491C2.10493 24.1615 1.99951 23.907 1.99951 23.6416C1.99951 23.3762 2.10493 23.1217 2.29257 22.9341L11.2926 13.9341C11.3854 13.8411 11.4957 13.7674 11.6171 13.717C11.7385 13.6667 11.8687 13.6408 12.0001 13.6408C12.1315 13.6408 12.2616 13.6667 12.383 13.717C12.5044 13.7674 12.6147 13.8411 12.7076 13.9341L17.0001 18.2279L26.5863 8.6416H21.0001C20.7349 8.6416 20.4805 8.53624 20.293 8.34871C20.1054 8.16117 20.0001 7.90682 20.0001 7.6416C20.0001 7.37639 20.1054 7.12203 20.293 6.93449C20.4805 6.74696 20.7349 6.6416 21.0001 6.6416H29.0001C29.2653 6.6416 29.5196 6.74696 29.7072 6.93449C29.8947 7.12203 30.0001 7.37639 30.0001 7.6416Z",
    fill: "#067647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighProduct);
export default __webpack_public_path__ + "static/media/high_product.9fe4bf7f96199634dfe23826177e0213.svg";
export { ForwardRef as ReactComponent };